import {
  Box,
  Typography,
  FormControlLabel,
  RadioGroup,
  Radio,
  DialogActions,
} from "@mui/material";
import { useState } from "react";
import FormTextField from "../ui/FormTextField";
import { PrimaryButton } from "../ui/PrimaryButton";
import { SecondaryButton } from "../ui/SecondaryButton";

function QuantityForm({ onClose, quantity, setQuantity }) {
  const [mode, setMode] = useState("amount"); // "amount" or "unlimited"

  const handleSubmit = () => {
    const finalQuantity = mode === "unlimited" ? "unlimited" : quantity;
    console.log("Submit quantity:", finalQuantity);

    onClose();
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Виберіть тип кількості
      </Typography>

      {mode === "amount" && (
        <Box sx={{ mt: 2, mb: 2 }}>
          <FormTextField
            label="К-ть товару"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            type="number"
            fullWidth
            placeholder="Введіть кількість"
          />
        </Box>
      )}
      <RadioGroup
        row
        value={mode}
        onChange={(e) => setMode(e.target.value)}
        sx={{ gap: 2, mb: 2 }}
      >
        <FormControlLabel
          value="amount"
          control={<Radio />}
          label="Вказати кількість"
        />
        <FormControlLabel
          value="unlimited"
          control={<Radio />}
          label="Без кількості (Обмеженно)"
        />
      </RadioGroup>

      <DialogActions sx={{ p: 0, justifyContent: "start" }}>
        <PrimaryButton onClick={handleSubmit}>Зберегти</PrimaryButton>
        <SecondaryButton onClick={onClose}>Закрити</SecondaryButton>
      </DialogActions>
    </Box>
  );
}

export default QuantityForm;
